import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthorizationViewModel } from '@viewModels/AuthorizationViewModel/AuthorizationViewModel';
import { BasicLoader } from '@shared/Ui/Loaders/BasicLoader/BasicLoader';
import { useUserInfoViewModel } from '@viewModels/UserInfoViewModel/UserInfoViewModel';
import { ROUTES } from '@configs/AppRoutes';

interface ProtectedRoute {
    children: React.ReactElement;
    requireProject?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRoute> = ({
    children,
    requireProject = true,
}) => {
    const { fetchMyProfileInfo, currentUser } = useUserInfoViewModel();
    const { getToken, isAuthorizationLoading } = useAuthorizationViewModel();

    const [hasProject, setHasProject] = useState<boolean | null>(null);
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

    useEffect(() => {
        const fetchCheckAuthorization = async () => {
            const token = await getToken();
            if (token !== null && token !== '') {
                setIsAuthorized(true);
                await fetchMyProfileInfo();
                setHasProject(currentUser.projectsCount > 0);
            } else {
                setIsAuthorized(false);
                setHasProject(false);
            }
        };

        fetchCheckAuthorization();
    }, [hasProject]);

    const isProjectCheckPending = requireProject && hasProject === null;

    if (
        isAuthorizationLoading ||
        isAuthorized === null ||
        isProjectCheckPending
    ) {
        return <BasicLoader />;
    }

    if (!isAuthorized || (requireProject && !hasProject)) {
        return <Navigate to={ROUTES.HOME} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
